export const elms = {
  ham: document.querySelector('.c-ham'),
  header: document.querySelector('.l-header'),
};
